export default function SocialProof() {
  return (
    <div
      data-testid="social-proof-counter"
      className="mt-8 flex items-center gap-4"
    >
      <div className="flex -space-x-2" aria-hidden="true">
        {["A", "K", "M"].map((letter) => (
          <span
            key={letter}
            className="w-8 h-8 rounded-full border-2 flex items-center justify-center font-mono text-[10px] uppercase tracking-wide"
            style={{
              background: "var(--surface)",
              borderColor: "var(--page)",
              color: "var(--text-secondary)",
            }}
          >
            {letter}
          </span>
        ))}
      </div>
      <p className="text-sm font-mono text-secondary">
        Joined by <span className="text-primary">2,400+</span> founders &amp; creators
      </p>
    </div>
  );
}
